import { styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { ControlledTextInput } from '../../../../components/ControlledTextInput';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  NetSuiteConfigurationControl,
  NetSuiteConfigurationFormValues,
} from '../../NetSuiteConfigurationFormSchema';

type AccountConfigurationSectionProps = {
  defaultValues: NetSuiteConfigurationFormValues;
  control: NetSuiteConfigurationControl;
};

export const AccountConfigurationSection: FC<AccountConfigurationSectionProps> = ({ 
  control, 
  defaultValues 
}) => {
  return (
    <ConfigurationSection title="Receivable Account" iconName="Key">
      <TextInputContainer>
        <Typography
          sx={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '12px',
          }}
        >
          Default Receivable Account
        </Typography>
        <ControlledTextInput
          name="defaultReceivableAccount"
          control={control}
          placeholder="Enter default receivable account..."
          defaultValue={defaultValues.defaultReceivableAccount}
        />
      </TextInputContainer>
    </ConfigurationSection>
  );
};

const TextInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}); 